import { render } from "./AppStaffStat.vue?vue&type=template&id=437deda4&scoped=true"
import script from "./AppStaffStat.vue?vue&type=script&lang=js"
export * from "./AppStaffStat.vue?vue&type=script&lang=js"

import "./AppStaffStat.vue?vue&type=style&index=0&id=437deda4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437deda4"]])

export default __exports__